import apiCtrl from '@/services/api/abstract/abstract-api.js';
const moment = require('moment');
require('moment/locale/es');
export default {
  props: {
    entity: String,
    dateField: String,
    searchInput: Boolean,
    fetchUrl: String,
  },
  data() {
    return {
      items: [],
      config: {},
      configReady: false,
      itemsReady: false,
      dateRangeReady: false,
      from: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      to: moment()
        .endOf('month')
        .format('YYYY-MM-DD'),
      params: {
        search: '',
        datesearch: {},
      },
      search: '',
    };
  },
  mounted() {
    this.getConfig();
    this.setDateRange(this.from, this.to);
  },
  computed: {
    readyToList() {
      return this.configReady && this.itemsReady;
    },
  },
  methods: {
    getEntities() {
      this.itemsReady = false;
      let config = {};
      config.params = this.params;
      apiCtrl.get(this.fetchUrl ? this.fetchUrl : '/' + this.entity, config).then(res => {
        this.items = res.data.data;
        if (res.data.hasOwnProperty('meta')) {
          this.pagination = res.data.meta;
          this.showPagination = true;
        }
        this.itemsReady = true;
      });
    },
    setDateRange(from, to) {
      this.dateRangeReady = false;
      this.from = moment(from).format('YYYY-MM-DD');
      this.to = moment(to).format('YYYY-MM-DD');
      this.params.datesearch[this.dateField] = this.from + ';' + this.to;
      this.dateRangeReady = true;
    },
    getConfig() {
      this.configReady = false;
      apiCtrl.get('/config/' + this.entity).then(res => {
        this.config = res.data.data;
        this.configReady = true;
      });
    },

    setPagination: function(meta) {
      this.pagination = meta;
      this.showPagination = true;
    },
  },
  watch: {
    page: function(val, oldVal) {
      this.params.page = val;

      this.getEntities();
    },
  },
};
